import React from "react";
import {wrapLinkContent} from "../LocServices/wrapLinkContent"

export default function SearchContent (props) {
  const {req_found_rows} = props
  if (req_found_rows === null) return <></>

  //console.log(req_found_rows)
  return (
    <div className="row">
      {req_found_rows.map((item, index) => (
        <div key={index} className="col-md-4 mb-4">
          <div className="card border" style={{ backgroundColor: "transparent" }}>
            <div className="card-body">
              <h5 className="card-title">
                <a href={`/locator_simple_finder/${item.id}`}> <button type="button" className="btn btn-outline-primary btn-block">Location #{item.id}</button></a>
              </h5>
              <p className="card-text">
              {wrapLinkContent(item.text)}
              </p>
              <p className="card-text">
                <strong>Description:</strong> {item.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}